<div
    #mapElement
    class="bazis-map"
    [class.bazis-map_grayscale]="tileMode === 'grey'"
></div>
